import { Button } from 'components/atoms';
import { PiArrowsClockwise, PiWarning } from 'react-icons/pi';
import ApplicationAnnouncementWrapper from '../wrapper/ApplicationAnnouncementWrapper';

const VersionApplicationAnnouncement = () => {
  return <></>;
  return (
    <ApplicationAnnouncementWrapper
      icon={<PiWarning />}
      description="Nowa wersja aplikacji jest już dostępna. Odśwież stronę przyciskiem obok aby zobaczyć zmiany (t)"
      action={
        <Button isClear onlyIcon>
          <Button.Icon icon={<PiArrowsClockwise />} />
        </Button>
      }
    />
  );
};

export default VersionApplicationAnnouncement;
